var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.712,
    height: 20.712,
    viewBox: "0 0 20.712 20.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_link-2",
    "data-name": "vuesax/bulk/link-2",
    transform: "translate(-108 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-2",
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.536,1.663A5.682,5.682,0,0,1,6.869,11.2a5.664,5.664,0,0,0-1.5-5.368A5.664,5.664,0,0,0,0,4.33,5.682,5.682,0,0,1,9.536,1.663Z",
    transform: "translate(6.921 2.591)",
    fill: "#020d88",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.7,1.665A5.68,5.68,0,1,1,4.33.164,5.664,5.664,0,0,1,9.7,1.665Z",
    transform: "translate(2.591 6.757)",
    fill: "#020d88",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.689,9.695A.629.629,0,0,1,8.8,8.806a4.418,4.418,0,1,0-6.248,0,.629.629,0,1,1-.889.889,5.681,5.681,0,1,1,8.026,0Z",
    transform: "translate(6.768 2.594)",
    fill: "#020d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.665.188a.62.62,0,0,1,.889,0,.62.62,0,0,1,0,.889,4.418,4.418,0,1,0,6.248,0,.62.62,0,0,1,0-.889.62.62,0,0,1,.889,0,5.681,5.681,0,1,1-8.026,0Z",
    transform: "translate(2.59 8.235)",
    fill: "#020d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H20.712V20.712H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLink);
export default __webpack_public_path__ + "static/media/page-link.f78c5663e78f447fca95c7a335252141.svg";
export { ForwardRef as ReactComponent };